import React from "react";

const AwardIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8983 10.7422L14.1608 17.8472C14.1749 17.9309 14.1632 18.0168 14.1271 18.0936C14.0911 18.1705 14.0324 18.2344 13.959 18.277C13.8857 18.3196 13.801 18.3388 13.7164 18.3319C13.6319 18.3251 13.5514 18.2926 13.4858 18.2389L10.5024 15.9997C10.3584 15.8921 10.1835 15.834 10.0037 15.834C9.82391 15.834 9.64896 15.8921 9.50494 15.9997L6.5166 18.238C6.45104 18.2917 6.37065 18.3241 6.28618 18.331C6.20171 18.3378 6.11716 18.3187 6.04382 18.2762C5.97048 18.2338 5.91183 18.17 5.8757 18.0933C5.83957 18.0166 5.82768 17.9308 5.8416 17.8472L7.10327 10.7422"
        stroke="#379fff"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.6719C12.7614 11.6719 15 9.4333 15 6.67188C15 3.91045 12.7614 1.67188 10 1.67188C7.23858 1.67188 5 3.91045 5 6.67188C5 9.4333 7.23858 11.6719 10 11.6719Z"
        stroke="#379fff"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AwardIcon;
